﻿module.exports = function ($) {
    return {
        init: function () {
            $(".memberForm__button__edit a").on("click",
                function () {
                    $(".readonly_mode").hide();
                    $(".edit_mode").show();
                    $("#ProfileForm").find("input,select").prop("disabled", false);
                });
            $(".memberForm__button__cancel a").on("click",
                function () {
                    $(".readonly_mode").show();
                    $(".edit_mode").hide();
                    $("#ProfileForm").find("input,select").prop("disabled", true);
                });
            if ($("#ProfileForm").find(".field-validation-error").length > 0) {
                $(".memberForm__button__edit:first a:first").trigger("click");
            }
            $("#ProfileForm input").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    if ($(this).prop("disabled") === undefined || $(this).prop("disabled") === false) {
                        $("#ProfileForm").submit();
                    }
                }
            });
            $("#ProfilePasswordForm input").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    $("#ProfilePasswordForm").submit();
                }
            });
        }
    }
}